import {useSyncExternalStore} from 'react';

let slot: HTMLElement | null = null;
const listeners = new Set<() => void>();

function emit(): void {
  listeners.forEach(listener => listener());
}

export const outletSlot = {
  get(): HTMLElement | null {
    return slot;
  },
  set(element: HTMLElement): void {
    slot = element;
    emit();
  },
  clear(element: HTMLElement): void {
    if (slot === element) {
      slot = null;
      emit();
    }
  },
  subscribe(listener: () => void): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};

export function useOutletSlot(): HTMLElement | null {
  return useSyncExternalStore(outletSlot.subscribe, outletSlot.get);
}
